
import { Component, Mixins, Emit } from 'vue-property-decorator';
import { iNetbar, iDevice, iNetbarRes, eDispatchType } from '../../../interface/result';
import { getAreaDetail, putAreaDetail, delAreaDetail, putDispatchType } from '@/api/deviceManaging';
import { GameArea } from '@/mixins/game_area';
import { PageQuery } from '@/mixins/page_query';
import { toast } from '@/utils/common';
import Detail from '@/views/schedule/area_manage/components/_Detail.vue';
import Upload from './_Upload.vue';
import DispatchTypeDialog from './_DispatchTypeDialog.vue';
import LogUtils from 'panda-log';
import { switchWhiteList } from '../../../api/deviceManaging';

@Component({
  components: {
    Upload,
    DispatchTypeDialog,
    Detail,
  },
})
export default class DeviceTable extends Mixins(GameArea, PageQuery) {
  private dragerVisible = false;
  private isEdit = false;

  private dispatchTypeVisible = false;
  private query = {
    search: '',
    regionid: 0,
    ispublic: 1,
  };
  editor: boolean = false;
  visibleAreaDetail: boolean = false;
  private orginalTable = [];
  private deviceTable = [];
  private dispatchTypeList = [
    { id: eDispatchType.OWN_DISPACTH, name: '独立调度' },
    { id: eDispatchType.UNIFY_DISPACTH, name: '统一调度' },
    { id: eDispatchType.PUBLIC_DISPACTH, name: '共享调度' },
  ];
  private selectedDispatchType: number = eDispatchType.OWN_DISPACTH;
  //加载数据状态
  loading: boolean = false;
  private model = {};
  private title = '';
  areaId = 0;
  @Emit() godetail(obj: iNetbar) {
    console.log('go detail', obj);
  }
  seeAreaDetail(item: any) {
    this.areaId = item.region_id;
    this.visibleAreaDetail = true;
  }
  closeDialog() {
    this.visibleAreaDetail = false;
  }
  handleUpload() {
    this.closeModal();
  }
  getDispatchType(dispatch_type: number) {
    let value = '无';
    const item = this.dispatchTypeList.find((item: any) => item.id == dispatch_type);
    if (item) {
      value = item.name;
    }
    return value;
  }
  closeModal() {
    this.dragerVisible = false;
    this.getNetbarDetail();
  }

  showEdit(row: iDevice) {
    if (row.dispatch_type) {
      this.selectedDispatchType = row.dispatch_type ? row.dispatch_type : eDispatchType.OWN_DISPACTH;
    }
    row.editor = true;
  }
  changeRowDispatchType(type: number) {
    this.selectedDispatchType = type;
  }
  cancelEdit(row: iDevice) {
    this.deviceTable = JSON.parse(JSON.stringify(this.orginalTable));
    row.editor = false;
  }

  removeRow(id: number) {
    const h = this.$createElement;
    this.$msgbox({
      title: '请确认要删除的机器',
      type: 'warning',
      message: h('p', undefined, [h('i', { style: 'color: red' }, '删除后不可恢复'), h('span', undefined, ' 你还要继续吗？ ')]),
      showCancelButton: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      beforeClose: async (action, instance, done) => {
        if (action === 'confirm') {
          instance.confirmButtonLoading = true;
          instance.confirmButtonText = '执行中...';
          // 发送删除请求
          await this.delRow(id);
          done();
          instance.confirmButtonLoading = false;
        } else {
          done();
        }
      },
    }).then(action => {
      // 再发送get请求表格数据
      this.getNetbarDetail();
      this.$message({
        type: 'success',
        message: '删除成功',
      });
    });
  }
  /**
   * 改变选择
   */
  changeSelect() {
    this.searchList();
  }
  searchList() {
    this.page_query.page = 1;
    this.getNetbarDetail();
  }

  async getNetbarDetail() {
    this.loading = true;
    try {
      const res = await getAreaDetail({ ...this.query, ...this.page_query });
      this.loading = false;
      if (res) {
        this.orginalTable = JSON.parse(JSON.stringify(res.data.list));
        this.deviceTable = res.data.list;
        this.total = res.data.total;
      }
    } catch (error) {
      this.loading = false;
      console.log(error);
    }
  }

  async updateRow(row: iNetbar) {
    const selectDispatchType = this.selectedDispatchType != eDispatchType.OWN_DISPACTH; //不是独立调度
    const isUpdateDispatchType = this.selectedDispatchType != row.dispatch_type; //是否修改了当前调度
    if (selectDispatchType && isUpdateDispatchType) {
      this.model = row;
      if (this.selectedDispatchType == eDispatchType.PUBLIC_DISPACTH) {
        this.title = '关联配置的调度池ID （在无盘系统的算力池ID）';
      } else {
        this.title = '关联配置的调度池ID,  pool_id,';
      }
      this.dispatchTypeVisible = true;
    } else {
      if (isUpdateDispatchType && !selectDispatchType) {
        this.updateNode(row, true);
      } else {
        this.updateNode(row);
      }
    }
  }
  async updateNode(row: iNetbar, isUpdateDispatch: boolean = false) {
    try {
      row.cmd_port = Number(row.cmd_port);
      row.dispatch_type = this.selectedDispatchType;
      const res = await putAreaDetail(row);
      let resDispatchType;
      this.loading = true;
      //是否修改调度类型
      const { dispatch_type, low_pool_id, high_pool_id, free_pool_id, id, lux_pool_id, port_mapping_prefix } = row;
      if (isUpdateDispatch) {
        resDispatchType = await putDispatchType({ id, dispatch_type, low_pool_id, high_pool_id, free_pool_id, lux_pool_id, port_mapping_prefix });
      }
      if (res && res.code === 0) {
        //是否修改调度类型
        if (isUpdateDispatch) {
          if (resDispatchType && resDispatchType.code === 0) {
            this.saveSuccess();
          } else {
            toast(resDispatchType.msg, 'error', 3000);
            this.saveSuccess();
          }
        } else {
          this.saveSuccess();
        }
      } else {
        const error = res.msg ? res.msg : resDispatchType.msg;
        toast(error, 'error');
      }
    } catch (error) {
      toast(error, 'error');
    } finally {
      this.loading = false;
    }
  }
  saveSuccess() {
    this.isEdit = false;
    this.getNetbarDetail();
    this.dispatchTypeVisible = false;
    toast('修改成功！');
  }
  handleUpdate(model: iNetbar) {
    this.updateNode(model, true);
  }
  handleCloseUpdate() {
    this.dispatchTypeVisible = false;
    this.isEdit = false;
    this.deviceTable = JSON.parse(JSON.stringify(this.orginalTable));
  }
  async delRow(id: number) {
    try {
      const res = await delAreaDetail(id);
      if (res) {
        // toast(res.msg);
        // console.log(res);
      }
    } catch (error) {
      console.log(error);
    }
  }
  /**
   * 排序变化
   */
  sortChange(e: any) {
    LogUtils.debug('e', e);
    this.loading = true;
    setTimeout(() => {
      this.loading = false;
      toast('排序成功');
    }, 2000);
  }

  /**
   * 修改是否受中心调度
   */
  async changeSchedule(info: iNetbarRes) {
    this.loading = true;
    try {
      await switchWhiteList(String(info.id));
      this.searchList();
      toast('修改成功');
    } catch (error) {
      LogUtils.warn('修改中心调度出错', error);
    } finally {
      this.loading = false;
    }
    LogUtils.debug(info);
  }

  mounted() {
    this.pageFn = this.getNetbarDetail;
    this.getNetbarDetail();
  }
}
